import React from 'react';
import { Card } from '@arco-design/web-react';

export default function HomeTipCard() {
  return (
    <Card style={{ background: '#3491FA1A', marginBottom: 16, margin: '10px 20px', boxShadow: '0 4px 16px rgba(0,0,0,0.08)' ,padding: '10px 36px', 
      borderRadius: 12}}>
      <h3 style={{ fontWeight: 700, color: '#222', margin: 0 }}>
        使用评论收集功能推荐使用Windows10/11系统电脑，Edge或Chrome浏览器，下载安装最新的评论收集插件，注意有原来的插件要删除，弹出此提示说明插件有更新
      </h3>
      <p style={{ fontSize: 15, color: '#444', fontFamily: '微软雅黑, Arial, sans-serif', margin: '12px 0 0 0' }}>
        安装或更新收集插件视频：
        <a
          href="https://xcn9f50y4vw5.feishu.cn/wiki/Y26hwDUgAioiDzkv7CbcZFC5n1b#share=ZPBed4YFSolUMxASrvc65zJn8g"
          target="_blank"
          rel="noreferrer"
          style={{ color: '#3491fa', marginLeft: 4 }}
        >
          查看视频教程
        </a>
      </p>
      <p style={{ fontSize: 15, color: '#444', fontFamily: '微软雅黑, Arial, sans-serif', margin: '8px 0' }}>
        1. 点击右侧下载
        <a
          href="https://iyr-1256349444.cos.ap-guangzhou.myqcloud.com/%E5%85%85%E6%8F%92%E5%92%8C%E6%94%AF%E6%8C%81%E6%8F%92%E4%BB%B6.zip"
          download="智能线索插件.zip"
          style={{ color: '#3491fa', margin: '0 4px' }}
        >
          .zip文件
        </a>
        并解压缩，得到插件的文件夹，注意安装完成后也不要移动和删除解压后的文件夹
      </p>
      <p style={{ fontSize: 15, color: '#444', fontFamily: '微软雅黑, Arial, sans-serif', margin: '8px 0' }}>
        2. 打开 Edge或Chrome 浏览器，复制 <code>chrome://extensions</code> 并粘贴到地址栏中，进入扩展设置。
      </p>
      <p style={{ fontSize: 15, color: '#444', fontFamily: '微软雅黑, Arial, sans-serif', margin: '8px 0' }}>
        3. 在扩展管理页面的右上角，打开“开发者模式”。
      </p>
      <p style={{ fontSize: 15, color: '#444', fontFamily: '微软雅黑, Arial, sans-serif', margin: '8px 0' }}>
        4. 点击左上角的“加载已解压的扩展程序”按钮，在弹出的文件选择对话框中，选择解压后的插件文件夹。（如果有旧版本的插件请移除）
      </p>
      <p style={{ fontSize: 15, color: '#444', fontFamily: '微软雅黑, Arial, sans-serif', margin: '8px 0' }}>
        5. 确认插件已安装，在扩展管理页面中，应该能够看到刚刚加载的插件，并且插件已经启用
      </p>
      <p style={{ fontSize: 15, color: '#444', fontFamily: '微软雅黑, Arial, sans-serif', margin: '8px 0' }}>
        6. 安装完成后，请刷新此页面，注意不要移动和删除解压后的插件文件夹
      </p>
    </Card>
  );
}